import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

/**
 * Unstyled Reusable Button Component
 * @param {object} props - props object
 * @param {function} props.onClick - function to be called when button is clicked
 * @param {boolean} props.disabled - boolean to disable button
 * @param {string} props.classNames - class names for button
 * @param {object} props.restAttributes - rest of the attributes for button
 * @param {node} props.children - children of button
 * @returns {element} - button
 */
const Button = forwardRef(
	({ onClick, disabled, classNames, children, ...restattributes }, ref) => (
		<button
			onClick={onClick}
			disabled={disabled}
			className={classNames}
			{...restattributes}
			type='button'
			ref={ref}
		>
			{children}
		</button>
	),
);

Button.propTypes = {
	onClick: PropTypes.func,
	disabled: PropTypes.bool,
	children: PropTypes.node.isRequired,
	classNames: PropTypes.string.isRequired,
	restattributes: PropTypes.object,
};

// Button.defaultProps = {
// 	onClick: () => {},
// 	disabled: false,
// 	restattributes: {},
// };

export default Button;
